<script>
import { required } from "vuelidate/lib/validators";
import CompanyType from "@/components/modals/company-type";

export default {
    components: {
        CompanyType,
    },
    data() {
        return {
            submitted: false,
            modalTitle: "Add Company",
            form: {
                id: 0,
                name: "",
                address: "",
                companyTypeId: "",
            },
            companyType: "",
        }
    },
    validations: {
        form: {
            name: { required },
            address: { required },
            companyTypeId: { required },
        },
    },
    methods: {
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$store
                .dispatch("company/CreateCompany", this.form)
                .then((res) => {
                    this.$emit('dropData', res.data)
                    this.$bvModal.hide("company-modal");
                    this.showToast("Successfully created!","success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!","error");
                });
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                address: "",
                companyTypeId: "",
            };
            this.companyType = "";
        },
        dropData(data){
            this.companyType = data.type;
            this.form.companyTypeId = data.id;
        },
        getCt() {
            this.$bvModal.show("company-type-modal");
        },
    }
}
</script>
<template>
    <b-modal
        id="company-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="name"> Name </label>
                <input
                    autocomplete="off"
                    id="name"
                    type="text"
                    v-model="form.name"
                    placeholder="Enter Name..."
                    class="form-control"
                    :class="{
                        'is-invalid':
                            submitted &&
                            $v.form.name.$error,
                    }"
                />
                <div
                    v-if="
                        submitted && $v.form.name.$error
                    "
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.name.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="address">Address </label>
                <textarea
                    id="address"
                    type="text"
                    v-model="form.address"
                    placeholder="Enter Address..."
                    class="form-control"
                    :class="{
                        'is-invalid':
                            submitted &&
                            $v.form.address.$error,
                    }"
                ></textarea>
                <div
                    v-if="
                        submitted &&
                        $v.form.address.$error
                    "
                    class="invalid-feedback"
                >
                    <span
                        v-if="!$v.form.address.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="companyTypeId"
                    >Company Type
                </label>
                <b-input-group>
                    <template #append>
                        <b-button
                            @click="getCt"
                            variant="outline-info"
                            ><i
                                class="
                                    mdi
                                    mdi-clipboard-text-search-outline
                                "
                            ></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Company Type..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.companyTypeId
                                    .$error,
                        }"
                        v-model="companyType"
                    />
                </b-input-group>
                <div
                    v-if="
                        submitted &&
                        $v.form.companyTypeId.$error
                    "
                    class="invalid-feedback"
                >
                    <span
                        v-if="
                            !$v.form.companyTypeId
                                .required
                        "
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="submit"
                    class="btn btn-primary"
                >
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('company-modal')"
                >
                    Close
                </button>
            </div>
        </form>
        <company-type v-on:dropData="dropData($event)"></company-type>
    </b-modal>
</template>